<template>
  <div class="h-0">
    <!-- 危险有害因素辨识清单 -->
    <!-- <danger-identify-list
      v-if="dangerIdentifyShow"
      :areaId="transferProps.areaId"
      @cancel="cancel('dangerIdentifyShow')"
    ></danger-identify-list> -->
    <!-- 响应升级 -->
    <UpLevelDialog
      v-if="upLevelDialog"
      :propData="upLevelformData"
      @handleOk="handleOk"
      @close="upLevelDialog = false"
    />
    <!-- 应急物资 -->
    <EmergencyMatterDialog
      v-if="emergencyMatterDialog"
      :propData="emergencyMatterformData"
      @handleOk="handleOk"
      @close="emergencyMatterDialog = false"
    />
    <EscapeRouteDialog
      v-if="EscapeRouteDialog"
      :propData="EscapeRouteformData"
      @handleOk="handleOk"
      @close="EscapeRouteDialog = false"
    />
    <SafetyIslandDialog
      v-if="SafetyIslandDialog"
      :propData="SafetyIslandformData"
      @handleOk="handleOk"
      @close="SafetyIslandDialog = false"
    />
    <!-- 事故事件创建 -->
    <AccidentDialog
      v-if="accidentDialog"
      :propData="accidentformData"
      @handleOk="handleOk"
      @close="accidentDialog = false"
    />
    <!-- 响应弹窗 -->
    <MapResponseDialog
      v-if="mapResponseDialog"
      :FormData="mapResponseformData"
      @handleOk="handleOk"
      @close="mapResponseDialog = false"
    />
    <!-- 应急处置卡的处理弹窗 -->
    <DealAlarmDialog
      v-if="dealAlarmDialog"
      :propData="dealAlarmformData"
      @close="dealAlarmDialog = false"
    />
  </div>
</template>
<script>
import { isEmpty, flatten, map, cloneDeep, filter, some, isNil } from 'lodash'
import EmergencyMatterDialog from './EmergencyDisposalDialog/EmergencyMatterDialog'
import EscapeRouteDialog from './EmergencyDisposalDialog/EscapeRouteDialog'
import SafetyIslandDialog from './EmergencyDisposalDialog/SafetyIslandDialog'
import UpLevelDialog from './EmergencyDisposalDialog/UpLevelDialog'
import AccidentDialog from './EmergencyDisposalDialog/AccidentDialog'
import MapResponseDialog from './EmergencyDisposalDialog/MapResponseDialog'
import DealAlarmDialog from './EmergencyDisposalDialog/DealAlarmDialog'

export default {
  components: {
    EmergencyMatterDialog,
    EscapeRouteDialog,
    SafetyIslandDialog,
    UpLevelDialog,
    AccidentDialog,
    MapResponseDialog,
    DealAlarmDialog,
  },
  data() {
    return {
      // 响应
      upLevelDialog: false,
      upLevelformData: {},
      // 应急物资
      accidentDialog: false,
      emergencyMatterDialog: false,
      mapResponseDialog: false,
      accidentformData: {},
      emergencyMatterformData: {},
      // 疏散路径
      EscapeRouteDialog: false,
      EscapeRouteformData: {},
      // 安全岛
      SafetyIslandDialog: false,
      SafetyIslandformData: {},
      mapResponseformData: {},
      // 应急处置卡的处理弹窗
      dealAlarmDialog: false,
      dealAlarmformData: {},
    }
  },
  created() {},
  mounted() {
    window.addEventListener('openEmergencyDisposalDialog', this.getData)
  },
  beforeDestroy() {
    // window.removeEventListener('openEmergencyDisposalDialog', this.getData)
  },
  watch: {
    mapResponseDialog(val) {
      if (val) {
        // 如果是响应关闭右侧处置面板
        this.$emit('close')
      }
    },
  },
  methods: {
    setData(row, type) {
      this[`${type}formData`] = row
    },
    closeAllDialog() {
      this.upLevelDialog = false
      this.emergencyMatterDialog = false
      this.EscapeRouteDialog = false
      this.SafetyIslandDialog = false
      this.accidentDialog = false
      this.mapResponseDialog = false
      this.dealAlarmDialog = false
    },
    handleOk() {
      this.upLevelDialog = false
      this.accidentDialog = false
      this.$emit('close')
    },
    getData(e) {
      if (!isEmpty(e?.detail?.row)) {
        this.setData(e.detail.row, e.detail.type)
        this.closeAllDialog()
        const type = e.detail.type
        this.$nextTick(() => {
          this[`${type}Dialog`] = true
        })
      }
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped></style>
